// Daftar subkategori berdasarkan kategori
const SubkategoriMengelolaDiri = [
  {
    kategori: "Mengelola Diri",
    rowspan: 3,
    subkategori: "Adaptasi Terhadap Perubahan",
  },
  { kategori: "", subkategori: "Integritas" },
  { kategori: "", subkategori: "Komitmen Pada Pengembangan" },
];

const SubkategoriMengelolaOrangLain = [
  {
    kategori: "Mengelola Orang Lain",
    rowspan: 3,
    subkategori: "Orientasi pada Pelayanan",
  },
  { kategori: "", subkategori: "Kerjasama" },
  { kategori: "", subkategori: "Komunikasi" },
];

const SubkategoriMengelolaPekerjaan = [
  {
    kategori: "Mengelola Pekerjaan",
    rowspan: 4,
    subkategori: "Analisa Masalah",
  },
  { kategori: "", subkategori: "Orientasi pada Kualitas" },
  { kategori: "", subkategori: "Inovasi" },
  { kategori: "", subkategori: "Perencanaan" },
];

const SubkategoriKebutuhanPengembanganDiri = [
  {
    kategori: "Kebutuhan Pengembangan Diri",
    rowSpan: 1,
    colSpan: 2,
  },
];

export const RekapSubkategoriIndividu = [
  ...SubkategoriMengelolaDiri,
  ...SubkategoriMengelolaOrangLain,
  ...SubkategoriMengelolaPekerjaan,
  ...SubkategoriKebutuhanPengembanganDiri,
];

export const RekapSubkategoriKelompok = [
  ...SubkategoriMengelolaOrangLain,
  ...SubkategoriMengelolaPekerjaan,
];
